import { useMutation, useQueryClient } from '@tanstack/react-query';
import Api, { withAcl } from 'hooks/Api';
import { useProvider } from 'utils/providers/Provider';
import { toastSuccess } from 'ui/partials/Toast';
import { useAdminParams } from 'utils/helpers';

import c from '../utils/constants';

export default function useDeleteData() {
  const queryClient = useQueryClient();
  const { state } = useProvider();
  const args = state;
  const { accountId, accountUserId } = useAdminParams();

  return useMutation({
    mutationFn: async (id: string) => {
      const api = new Api(args);

      const data = await api.delete(
        await withAcl({
          account: {
            url: `/api/v3/data/${id}`,
          },
          admin: {
            url: `/api/v2/accounts/${accountId}/users/${accountUserId}/data/${id}`,
          },
        }),
      );

      return data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [c.FIELDS] });

      toastSuccess(`Successfully deleted field.`);
    },
  });
}
